import { render, staticRenderFns } from "./WorkcentersTable.vue?vue&type=template&id=1c137d09&"
import script from "./WorkcentersTable.vue?vue&type=script&lang=js&"
export * from "./WorkcentersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports